import i18n from '@/f1/service/i18n';

import KO from './i18n.ko.new';
import EN from './i18n.en.new';
import JP from './i18n.jp.new';

export default i18n({ EN, KO, JP });
